//
// Copyright 2023 DXOS.org
//

import type * as Theme from '@dxos/react-ui/Theme';

export const translations = [
  {
    'en-US': {
      testbench: {},
    },
  },
] as const satisfies Theme.Resource[];
